import React, { useEffect, useRef } from 'react';

function TurnstileWidget({ onVerify }) {
  const widgetRef = useRef(null);
  const rendered = useRef(false);
  const widgetId = useRef(null);

  useEffect(() => {
    const sitekey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
    if (!sitekey) {
      console.error("Turnstile sitekey is missing. Check your environment variables.");
      return;
    }

    function renderWidget() {
      if (!rendered.current && window.turnstile && widgetRef.current) {
        widgetId.current = window.turnstile.render(widgetRef.current, {
          sitekey,
          callback: onVerify,
          'error-callback': () => onVerify(null),
          'expired-callback': () => {
            onVerify(null);
            if (widgetId.current != null) window.turnstile.reset(widgetId.current);
          }
        });
        rendered.current = true;
      }
    }

    if (window.turnstile) {
      renderWidget();
    } else {
      const scriptId = 'cf-turnstile-script';
      if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onTurnstileLoad';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
      }
      window.onTurnstileLoad = () => {
        renderWidget();
      };
    }

    return () => {
      rendered.current = false;
      widgetId.current = null;
    };
  }, [onVerify]);

  return <div ref={widgetRef} className="turnstile-widget" />;
}

export default TurnstileWidget;
